
import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  Provider,
} from 'react-redux';
import { I18nextProvider } from 'react-i18next';

import App from './App';
import i18next from './i18next';
import store from './redux/store';
import { enableMapSet } from 'immer';

enableMapSet();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
        <App />
    </I18nextProvider>
  </Provider>
);